/* eslint-disable jsx-a11y/no-onchange */
import PropTypes from "prop-types"
import { isEqual } from "utils/helpers"
import { StackView } from "@planningcenter/tapestry-react"
const AreaFormGrades = ({
  gradeOptions,
  gradeRestrictionType,
  onGradeRestrictionChange,
  minGrade,
  onMinGradeChange,
  maxGrade,
  onMaxGradeChange,
  validation
}) => {
  return (
    <StackView axis="horizontal" wrap spacing={1} marginBottom={1}>
      <div>
        <label className="screen-reader-text" htmlFor="gradeRestrictionType">
          Restrict by Grades
        </label>
        <select
          className="select"
          name="gradeRestrictionType"
          value={gradeRestrictionType}
          onChange={e => onGradeRestrictionChange(e.target.value)}
        >
          <option value="between">between</option>
          <option value="only">only</option>
        </select>
        {validation.minGrade && <div className="c-error font-size-5">{validation.minGrade}</div>}
      </div>

      <div>
        <label className="screen-reader-text" htmlFor="minGrade">
          Minimum grade
        </label>
        <select
          className="select"
          name="minGrade"
          value={minGrade}
          onChange={e => onMinGradeChange(e.target.value)}
        >
          <option value={"-2"}>Any grade</option>
          {Object.entries(gradeOptions).map(([k, v]) => (
            <option key={v} value={v}>
              {k}
            </option>
          ))}
        </select>
      </div>

      {isEqual(gradeRestrictionType, "between") && <div className="pt-1">and</div>}

      {isEqual(gradeRestrictionType, "between") && (
        <div>
          <label className="screen-reader-text" htmlFor="maxGrade">
            Maximum grade
          </label>
          <select
            className="select w-a"
            name="maxGrade"
            value={maxGrade}
            onChange={e => onMaxGradeChange(e.target.value)}
          >
            <option value={"-2"}>Any grade</option>
            {Object.entries(gradeOptions).map(([k, v]) => (
              <option key={v} value={v}>
                {k}
              </option>
            ))}
          </select>
        </div>
      )}
    </StackView>
  )
}

AreaFormGrades.propTypes = {
  validation: PropTypes.shape({
    minGrade: PropTypes.string
  }),
  gradeOptions: PropTypes.shape({}),
  gradeRestrictionType: PropTypes.string,
  minGrade: PropTypes.string,
  maxGrade: PropTypes.string,
  onGradeRestrictionChange: PropTypes.func,
  onMinGradeChange: PropTypes.func,
  onMaxGradeChange: PropTypes.func
}

export default AreaFormGrades
